
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/child-safety",
      function () {
        return require("private-next-pages/child-safety.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/child-safety"])
      });
    }
  